"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var AngleDown_exports = {};
__export(AngleDown_exports, {
  default: () => AngleDown_default
});
module.exports = __toCommonJS(AngleDown_exports);
var import_jsx_runtime = require("react/jsx-runtime");
const svgContent = (props, title, titleId, desc, descId) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
  "svg",
  __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    children: [
      desc ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("desc", { id: descId, children: desc }) : null,
      title ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        "path",
        {
          d: "M22.2892 6.29429L12.7723 15.6125C12.6794 15.7058 12.569 15.7798 12.4474 15.8303C12.3258 15.8808 12.1954 15.9068 12.0638 15.9068C11.9321 15.9068 11.8018 15.8808 11.6802 15.8303C11.5586 15.7798 11.4482 15.7058 11.3553 15.6125L1.71129 6.37079C1.61838 6.27751 1.50797 6.2035 1.38638 6.153C1.2648 6.10249 1.13444 6.0765 1.00279 6.0765C0.871135 6.0765 0.740777 6.10249 0.619195 6.153C0.497612 6.2035 0.387199 6.27751 0.294289 6.37079C0.201012 6.4637 0.127 6.57411 0.0764983 6.69569C0.0259967 6.81728 0 6.94763 0 7.07929C0 7.21094 0.0259967 7.3413 0.0764983 7.46288C0.127 7.58446 0.201012 7.69488 0.294289 7.78779L9.9403 17.0255C10.5042 17.5884 11.2685 17.9045 12.0653 17.9045C12.8621 17.9045 13.6263 17.5884 14.1903 17.0255L23.7062 7.71029C23.7993 7.6174 23.8732 7.50705 23.9236 7.38556C23.974 7.26407 24 7.13382 24 7.00229C24 6.87075 23.974 6.74051 23.9236 6.61902C23.8732 6.49753 23.7993 6.38718 23.7062 6.29429C23.6133 6.20101 23.5029 6.127 23.3813 6.0765C23.2597 6.026 23.1294 6 22.9977 6C22.8661 6 22.7357 6.026 22.6141 6.0765C22.4925 6.127 22.3821 6.20101 22.2892 6.29429Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
const SvgIcon = (_a) => {
  var _b = _a, {
    title,
    titleId,
    desc,
    descId,
    iconSize,
    ariaHidden,
    color
  } = _b, props = __objRest(_b, [
    "title",
    "titleId",
    "desc",
    "descId",
    "iconSize",
    "ariaHidden",
    "color"
  ]);
  const sizes = {
    s: "12px",
    m: "16px",
    l: "24px",
    inherit: "inherit"
    // inherits size from parent
  };
  const size = sizes[iconSize] || "inherit";
  const style = {
    width: size,
    height: size,
    display: "flex",
    color
    // Use the color prop for the icon color
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    "div",
    __spreadProps(__spreadValues({
      style,
      "aria-hidden": ariaHidden,
      id: descId ? descId : titleId
    }, props), {
      children: svgContent(props, title, titleId, desc, descId)
    })
  );
};
const SvgAngleDown = SvgIcon;
var AngleDown_default = SvgAngleDown;
//# sourceMappingURL=AngleDown.js.map